import { type Media, createMediaObject } from 'models';
import { useQuery } from 'query';
import { getVideoMedia } from '../services';
import { getMediaQueryKey } from './keys';

export const useGetVideoMedia = ({ mediaId, options }: { mediaId?: string; options?: { staleTime?: number } }) =>
  useQuery<Media>({
    enabled: Boolean(mediaId),
    async queryFn() {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- This will run only if `mediaId` is defined
      const { data } = await getVideoMedia({ id: mediaId! });

      return createMediaObject(data);
    },
    queryKey: getMediaQueryKey({ mediaId }),
    ...options,
  });
